module.exports = __webpack_public_path__ + "img/societaires.f516e42f.svg";